module.exports = {"140581001":"北城街道","140581002":"东城街道","140581003":"南城街道","140581101":"米山镇","140581102":"三甲镇","140581103":"神农镇","140581104":"陈区镇","140581105":"北诗镇","140581106":"河西镇","140581107":"马村镇","140581108":"野川镇","140581109":"寺庄镇","140581201":"建宁乡","140581202":"石末乡","140581203":"原村乡","140581204":"永录乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140581.json
// module id = 274
// module chunks = 0